import { Grid, Paper, TextField } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';

export default function SoloCompSimulazioniSrl(props: SimulazioniSrlInputProps) {
    const gClasses = globalStyles();

    const { state } = props;

    return (
        <React.Fragment>
            <Paper className={gClasses.mainPaper}>
            <SectionTitle primary={true} text="2° Simulazione - società non trasparente - compenso agli amministratori - nessun dividendo"></SectionTitle>
                <SectionTitle text="Società"></SectionTitle>
                <TextField
                    name="G48"
                    label="Ragione sociale"
                    value={state.datiSimulazioniSrl.G48}
                    className={gClasses.longTextFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="K62"
                            label="Utile di bilancio al lordo dell'IRES"
                            value={state.datiSimulazioniSrl.K62}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="D72"
                            label="Compensi agli amministratori"
                            value={state.datiSimulazioniSrl.D72}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I8"
                            label="Contributi su compensi agli amministratori (2/3)"
                            value={state.soloCompSimulazioniSrl.I8}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K63"
                            label="Variazioni fiscali in aumento"
                            value={state.datiSimulazioniSrl.K63}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K64"
                            label="Variazioni fiscali in diminuzione"
                            value={state.datiSimulazioniSrl.K64}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Reddito d'impresa - fiscale"
                            value={state.soloCompSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Imponibile IRES"
                            value={state.soloCompSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I13"
                            label="IRES"
                            value={state.soloCompSimulazioniSrl.I13}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I14"
                            label="Utile di bilancio"
                            value={state.soloCompSimulazioniSrl.I14}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                </Grid>
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="1° Socio"></SectionTitle>
                <TextField
                    name="C52"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C52}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E118"
                        label="Pensione"
                        value={state.datiSimulazioniSrl.E118}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E119"
                        label="Lav. dipendente e assim."
                        value={state.datiSimulazioniSrl.E119}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="G74"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G74}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="D25"
                        label="al netto di 1/3 contr."
                        value={state.soloCompSimulazioniSrl.D25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E25"
                        label="Compenso netto"
                        value={state.soloCompSimulazioniSrl.E25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E120"
                        label="Assimilati lav. dipendente"
                        value={state.datiSimulazioniSrl.E120}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E121"
                        label="Impr. minore/ Lav. auton."
                        value={state.datiSimulazioniSrl.E121}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E122"
                        label="Diversi lettere i) e l)"
                        value={state.datiSimulazioniSrl.E122}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E123"
                        label="Fabbricati locati"
                        value={state.datiSimulazioniSrl.E123}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E124"
                        label="Altri"
                        value={state.datiSimulazioniSrl.E124}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E125"
                        label="Abitazione principale"
                        value={state.datiSimulazioniSrl.E125}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E127"
                        label="Redditi a cedolare secca"
                        value={state.datiSimulazioniSrl.E127}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E37"
                        label="Reddito complessivo"
                        value={state.soloCompSimulazioniSrl.E37}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E38"
                        label="Redd. compl. per detraz."
                        value={state.soloCompSimulazioniSrl.E38}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G22"
                        label="Redditi IVS"
                        value={state.soloCompSimulazioniSrl.G22}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H22"
                        label="Contr. IVS"
                        value={state.soloCompSimulazioniSrl.H22}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I24"
                        label="Oneri deducibili"
                        value={state.soloCompSimulazioniSrl.I24}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I25"
                        label="Reddito imponibile"
                        value={state.soloCompSimulazioniSrl.I25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I26"
                        label="Irpef lorda"
                        value={state.soloCompSimulazioniSrl.I26}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I28"
                        label="Familiari a carico"
                        value={state.soloCompSimulazioniSrl.I28}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I29"
                        label="Lavoro dipend."
                        value={state.soloCompSimulazioniSrl.I29}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I30"
                        label="Pensione"
                        value={state.soloCompSimulazioniSrl.I30}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I32"
                        label="Impresa/lav. Auton. e lav. non dipend."
                        value={state.soloCompSimulazioniSrl.I32}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="L122"
                        label="Altre"
                        value={state.datiSimulazioniSrl.L122}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I34"
                        label="Tot. Detrazioni"
                        value={state.soloCompSimulazioniSrl.I34}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I36"
                        label="Irpef netta"
                        value={state.soloCompSimulazioniSrl.I36}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                    {/* <NumberField
                        name="G74"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G74}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K36"
                    label="Regionale"
                    value={state.soloCompSimulazioniSrl.K36}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M36"
                    label="Comunale"
                    value={state.soloCompSimulazioniSrl.M36}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="2° Socio"></SectionTitle>
                <TextField
                    name="C53"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C53}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E133"
                        label="Pensione"
                        value={state.datiSimulazioniSrl.E133}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E134"
                        label="Lav. dipendente e assim."
                        value={state.datiSimulazioniSrl.E134}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="G75"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G75}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="D56"
                        label="al netto di 1/3 contr."
                        value={state.soloCompSimulazioniSrl.D56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E56"
                        label="Compenso netto"
                        value={state.soloCompSimulazioniSrl.E56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E135"
                        label="Assimilati lav. dipendente"
                        value={state.datiSimulazioniSrl.E135}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E136"
                        label="Impr. minore/ Lav. auton."
                        value={state.datiSimulazioniSrl.E136}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E137"
                        label="Diversi lettere i) e l)"
                        value={state.datiSimulazioniSrl.E137}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E138"
                        label="Fabbricati locati"
                        value={state.datiSimulazioniSrl.E138}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E139"
                        label="Altri"
                        value={state.datiSimulazioniSrl.E139}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E140"
                        label="Abitazione principale"
                        value={state.datiSimulazioniSrl.E140}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E142"
                        label="Redditi a cedolare secca"
                        value={state.datiSimulazioniSrl.E142}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E68"
                        label="Reddito complessivo"
                        value={state.soloCompSimulazioniSrl.E68}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E69"
                        label="Redd. compl. per detraz."
                        value={state.soloCompSimulazioniSrl.E69}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G53"
                        label="Redditi IVS"
                        value={state.soloCompSimulazioniSrl.G53}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H53"
                        label="Contr. IVS"
                        value={state.soloCompSimulazioniSrl.H53}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I55"
                    label="Oneri deducibili"
                    value={state.soloCompSimulazioniSrl.I55}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I56"
                    label="Reddito imponibile"
                    value={state.soloCompSimulazioniSrl.I56}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I57"
                    label="Irpef lorda"
                    value={state.soloCompSimulazioniSrl.I57}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I59"
                    label="Familiari a carico"
                    value={state.soloCompSimulazioniSrl.I59}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I60"
                    label="Lavoro dipend."
                    value={state.soloCompSimulazioniSrl.I60}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I61"
                    label="Pensione"
                    value={state.soloCompSimulazioniSrl.I61}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I63"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.soloCompSimulazioniSrl.I63}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L137"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L137}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I65"
                    label="Tot. Detrazioni"
                    value={state.soloCompSimulazioniSrl.I65}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I67"
                    label="Irpef netta"
                    value={state.soloCompSimulazioniSrl.I67}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                    name="G75"
                    label="Compenso Ammin."
                    value={state.datiSimulazioniSrl.G75}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                /> */}
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K67"
                    label="Regionale"
                    value={state.soloCompSimulazioniSrl.K67}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M67"
                    label="Comunale"
                    value={state.soloCompSimulazioniSrl.M67}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="3° Socio"></SectionTitle>
                <TextField
                    name="C54"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C54}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <Grid container>
                    <NumberField
                        name="E147"
                        label="Pensione"
                        value={state.datiSimulazioniSrl.E147}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E148"
                        label="Lav. dipendente e assim."
                        value={state.datiSimulazioniSrl.E148}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="G76"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G76}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="D87"
                        label="al netto di 1/3 contr."
                        value={state.soloCompSimulazioniSrl.D87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E87"
                        label="Compenso netto"
                        value={state.soloCompSimulazioniSrl.E87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E149"
                        label="Assimilati lav. dipendente"
                        value={state.datiSimulazioniSrl.E149}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E150"
                        label="Impr. minore/ Lav. auton."
                        value={state.datiSimulazioniSrl.E150}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E151"
                        label="Diversi lettere i) e l)"
                        value={state.datiSimulazioniSrl.E151}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E152"
                        label="Fabbricati locati"
                        value={state.datiSimulazioniSrl.E152}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E153"
                        label="Altri"
                        value={state.datiSimulazioniSrl.E153}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E154"
                        label="Abitazione principale"
                        value={state.datiSimulazioniSrl.E154}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E156"
                        label="Redditi a cedolare secca"
                        value={state.datiSimulazioniSrl.E156}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E99"
                        label="Reddito complessivo"
                        value={state.soloCompSimulazioniSrl.E99}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="E100"
                        label="Redd. compl. per detraz."
                        value={state.soloCompSimulazioniSrl.E100}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                {/* <SectionSubTitle text="Previdenza"></SectionSubTitle> */}
                <Grid container>
                    <NumberField
                        name="G84"
                        label="Redditi IVS"
                        value={state.soloCompSimulazioniSrl.G84}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H84"
                        label="Contr. IVS"
                        value={state.soloCompSimulazioniSrl.H84}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I86"
                    label="Oneri deducibili"
                    value={state.soloCompSimulazioniSrl.I86}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I87"
                    label="Reddito imponibile"
                    value={state.soloCompSimulazioniSrl.I87}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I88"
                    label="Irpef lorda"
                    value={state.soloCompSimulazioniSrl.I88}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I90"
                    label="Familiari a carico"
                    value={state.soloCompSimulazioniSrl.I90}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I91"
                    label="Lavoro dipend."
                    value={state.soloCompSimulazioniSrl.I91}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I92"
                    label="Pensione"
                    value={state.soloCompSimulazioniSrl.I92}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I94"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.soloCompSimulazioniSrl.I94}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L151"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L151}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I96"
                    label="Tot. Detrazioni"
                    value={state.soloCompSimulazioniSrl.I96}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I98"
                    label="Irpef netta"
                    value={state.soloCompSimulazioniSrl.I98}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                    name="G76"
                    label="Compenso Ammin."
                    value={state.datiSimulazioniSrl.G76}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                /> */}
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K98"
                    label="Regionale"
                    value={state.soloCompSimulazioniSrl.K98}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M98"
                    label="Comunale"
                    value={state.soloCompSimulazioniSrl.M98}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper >
        </React.Fragment>
    );
}